module.exports = __webpack_public_path__ + "static/media/introduce-1.a36a00ab.png";